import React, { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

/**
 * Toolbar toggle for the DataGrid Pro header filter row (off by default).
 * Pass `headerFilters` to the grid and drop `headerFilterButton` in the toolbar.
 */
export function useHeaderFilters() {
  const [headerFilters, setHeaderFilters] = useState(false);

  const headerFilterButton = (
    <Tooltip title="Show a filter box under every column header">
      <Button
        size="small"
        startIcon={<FilterAltIcon />}
        onClick={() => setHeaderFilters((on) => !on)}
        sx={{
          fontSize: "0.8125rem",
          backgroundColor: headerFilters ? "rgba(25,118,210,0.12)" : undefined,
        }}
      >
        Filter Row
      </Button>
    </Tooltip>
  );

  return { headerFilters, setHeaderFilters, headerFilterButton };
}
